import { useCallback, useState } from "react";
import { useChangeEffect } from "@ehynds/use-change-effect";
import { ProjectDraft } from "@hpo/client/models/Project";
import List, { ListItem } from "@hpo/client/utilities/List";
import SwitchField from "@hpo/client/utilities/fields/SwitchField";
import { CommitmentBeneficiary } from "@hpo/client/models/Commitment";

type ProjectCommitmentsProps = {
  project: ProjectDraft;
  onChange?: (d: Partial<ProjectDraft>) => unknown;
};

export default function ProjectCommitments(props: ProjectCommitmentsProps) {
  const { project, onChange } = props;

  const locked = onChange === undefined;

  function mustBeOn(value: boolean) {
    if (value === false)
      return "Vous devez vous assurer de respecter cet engagement";
    return null;
  }

  const [commitments, setCommitments] = useState<Array<CommitmentBeneficiary>>(
    project.commitments,
  );

  const setCommitmentAcceptedAt = useCallback(
    (id: string, value: boolean | null) => {
      setCommitments((current) => {
        return current.map((c) => {
          if (c.id === id)
            return { ...c, acceptedAt: value ? new Date() : null };
          else return c;
        });
      });
    },
    [],
  );

  useChangeEffect(() => {
    if (!onChange) return;
    onChange({ commitments });
  }, [commitments, onChange]);

  return (
    <List
      data={commitments}
      renderItem={(c) => (
        <ListItem
          label={c.label}
          right={
            <div css={{ width: 150, flexShrink: 0 }}>
              <SwitchField
                label="Je m'engage"
                required
                value={!!c.acceptedAt}
                onChange={(value) => setCommitmentAcceptedAt(c.id, value)}
                errorMessage={mustBeOn}
                readonly={locked}
              />
            </div>
          }
        />
      )}
    />
  );
}
